import { createSlice } from "@reduxjs/toolkit";

export const DisplayType = /** @type {const} */ ({
  MEASURES: "MEASURES",
  RECORDS: "RECORDS",
  SOLAR_PANELS: "SOLAR_PANELS",
});

export const initialState = {
  activeDisplayMode: DisplayType.MEASURES,
  mapType: "",
};

export const viewerSlice = createSlice({
  name: "viewer",
  initialState,
  reducers: {
    setDisplayMode: (state, action) => {
      state.activeDisplayMode = action.payload;
    },
    setMapType: (state, action) => {
      state.mapType = action.payload;
    },
  },
});

export const { setDisplayMode, setMapType } = viewerSlice.actions;

export default viewerSlice.reducer;
